const state = {
    treatmentRecipeLijst: [],
    treatmentActivityLijst: [],
    tacStatusLijst: [],
    treatStepLijst: [],
    uitbehandeldLijst: [],
    transformTypesLijst: []
};

export default state;

